module.exports = __webpack_public_path__ + "img/portrait.2941654f.png";